import React from 'react';
import { FiShield, FiCheckCircle, FiClock, FiActivity, FiFileText, FiBarChart2 } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Guarantee = () => (
  <section className="py-12 md:py-16 bg-slate-900 text-white">
    <div className="max-w-6xl mx-auto px-4 md:px-6">
      <div className="text-center mb-10">
        <SafeIcon icon={FiShield} className="w-12 h-12 md:w-16 md:h-16 text-green-400 mx-auto mb-4" />
        <h2 className="text-3xl md:text-4xl font-bold mb-3">14-Day Pilot + 30-Day Money-Back Guarantee</h2>
        <p className="text-lg md:text-xl text-slate-300 max-w-3xl mx-auto">
          You have 44 days to see this work before it costs you anything permanent. No setup fee. No commitment during the pilot.
        </p>
      </div>

      <div className="bg-slate-800 rounded-2xl p-6 md:p-8 mb-10 border border-slate-700">
        <h3 className="text-xl md:text-2xl font-bold mb-4 text-center text-white">How It Works:</h3>
        <div className="grid md:grid-cols-3 gap-6 text-center">
          {[
            { label: 'Days 1–14', desc: 'Free pilot. We set up your AI agent, integrate it with your systems, and route real calls to it. You monitor every interaction.' },
            { label: 'Day 14', desc: 'You decide if it\'s working. If not, walk away. No charge, no questions asked.' },
            { label: 'Days 15–44', desc: 'If you continue, the 30-day money-back guarantee starts. See results or get a full refund.' },
          ].map((item, i) => (
            <div key={i} className="bg-slate-700/50 rounded-xl p-5 border border-slate-600">
              <div className="text-sm font-bold text-green-400 mb-2">{item.label}</div>
              <p className="text-slate-300 text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="mb-10">
        <h3 className="text-xl md:text-2xl font-bold mb-6 text-center text-white">What "Results" Means:</h3>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {[
            { icon: FiClock, title: '24/7 Call Handling', desc: 'Calls handled without human intervention after hours and on weekends' },
            { icon: FiFileText, title: 'Auto Ticket Creation', desc: 'Tickets created and logged automatically in your helpdesk system' },
            { icon: FiActivity, title: 'Reduced Hold Times', desc: 'Measurable decrease in hold times and call abandonment rate' },
            { icon: FiCheckCircle, title: 'Fewer Tier-1 Escalations', desc: 'Routine calls handled without reaching your human team' },
            { icon: FiShield, title: 'Full Audit Trail', desc: 'Complete call recordings and transcripts for QA review' },
            { icon: FiClock, title: 'Hours Saved', desc: 'Measurable reduction in routine calls reaching your human team — tracked weekly' },
            { icon: FiBarChart2, title: 'Analytics & Visibility', desc: 'Full visibility into call patterns, resolution rates, and customer issues your team never had before' },
          ].map((item, i) => (
            <div key={i} className="bg-slate-800 p-5 rounded-xl border border-slate-700">
              <div className="w-10 h-10 bg-slate-700 rounded-lg flex items-center justify-center mb-3">
                <SafeIcon icon={item.icon} className="w-5 h-5 text-green-400" />
              </div>
              <h4 className="font-bold text-lg mb-1 text-white">{item.title}</h4>
              <p className="text-sm text-slate-300">{item.desc}</p>
            </div>
          ))}
          <div className="bg-slate-700/50 p-5 rounded-xl border border-slate-600 flex items-center justify-center">
            <p className="text-slate-200 text-center font-semibold text-sm">
              You'll know within 14 days whether this is working for your team.
            </p>
          </div>
        </div>
      </div>

      <div className="text-center">
        <p className="text-xl md:text-2xl font-bold text-white mb-2">
          We're confident you'll see fewer missed calls, lower operational costs, and a team that can focus on what matters.
        </p>
        <p className="text-lg text-slate-300">
          But if the system doesn't deliver after a full 30 days in production, you get a full refund.
        </p>
      </div>
    </div>
  </section>
);

export default Guarantee;